module.exports = __webpack_public_path__ + "assets/img/cloud2.ca60605f.webp";